export default {
  methods: {
    /**
     * Handle API validation errors
     * @param {Object} error - Error object from catch block
     * @param {Object} validationErrors - Object to store field-specific errors
     * @param {Array} errors - Array to store all error messages
     */
    handleValidationErrors(error, validationErrors, errors) {
      // Clear previous errors
      errors.splice(0, errors.length);
      Object.keys(validationErrors).forEach(
        (key) => delete validationErrors[key]
      );

      // Process errors from various sources
      if (error && error.response) {
        // Laravel validation errors (422 response)
        if (error.response.data && error.response.data.errors) {
          const serverErrors = error.response.data.errors;
          Object.keys(serverErrors).forEach((key) => {
            const errorMsg = Array.isArray(serverErrors[key])
              ? serverErrors[key][0]
              : serverErrors[key];

            errors.push(errorMsg);
            validationErrors[key] = errorMsg;
          });
        }
        // General error message from API
        else if (error.response.data && error.response.data.message) {
          errors.push(error.response.data.message);
        }
        // HTTP error without specific message
        else {
          errors.push(`Server returned an error (${error.response.status})`);
        }
      }
      // Check if errors are directly in error.errors (your new pattern)
      else if (error && error.errors) {
        Object.keys(error.errors).forEach((key) => {
          const errorMsg = Array.isArray(error.errors[key])
            ? error.errors[key][0]
            : error.errors[key];

          errors.push(errorMsg);
          validationErrors[key] = errorMsg;
        });

        // Add general message if available
        if (error.message) {
          // Only add if it's not already in the errors array
          if (!errors.includes(error.message)) {
            errors.push(error.message);
          }
        }
      }
      // Network error or other client-side error
      else if (error && error.message) {
        errors.push(error.message);
      }
      // Fallback for unknown errors
      else {
        errors.push("An unexpected error occurred");
      }
    },

    /**
     * Private method to validate video URL format (HTTP/HTTPS required)
     * @param {string} url - URL to validate
     * @returns {boolean} - Whether URL is valid
     * @private
     */
    _isVideoUrl(url) {
      if (!url) return false;
      // Require HTTP or HTTPS protocol
      const httpRegex = /^https?:\/\/.+/;
      return httpRegex.test(url);
    },

    /**
     * Validate form fields and collect errors
     * @returns {boolean} - Whether form is valid
     */
    validateForm() {
      this.validationErrors = {};
      this.errors = [];

      // Validate Smart Trainer
      if (!this.form.smartTrainer) {
        this.validationErrors.smartTrainer = "Please select your smart trainer";
        this.errors.push("Smart Trainer is required");
      }

      // Validate Secondary Power Source
      if (!this.form.secondaryPowerSource) {
        this.validationErrors.secondaryPowerSource =
          "Please select your secondary power source";
        this.errors.push("Secondary Power Source is required");
      }

      // Validate Weight
      if (!this.form.weight) {
        this.validationErrors.weight = "Weight is required";
        this.errors.push("Weight is required");
      } else if (this.form.weight < 25 || this.form.weight > 200) {
        this.validationErrors.weight =
          "Please enter a valid weight (25-200 kg)";
        this.errors.push("Please enter a valid weight (30-200 kg)");
      }

      // Validate Height
      if (!this.form.height) {
        this.validationErrors.height = "Height is required";
        this.errors.push("Height is required");
      } else if (this.form.height < 50 || this.form.height > 250) {
        this.validationErrors.height =
          "Please enter a valid height (50-250 cm)";
        this.errors.push("Please enter a valid height (50-250 cm)");
      }

      // Validate Video Link
      if (!this.form.videoLink) {
        this.validationErrors.videoLink = "Video link is required";
        this.errors.push("Video link is required");
      } else if (!this._isVideoUrl(this.form.videoLink)) {
        this.validationErrors.videoLink =
          "Please enter a valid HTTP or HTTPS video URL";
        this.errors.push("Please enter a valid HTTP or HTTPS video URL");
      }

      // Validate Strava Link
      if (!this.form.stravaLink) {
        this.validationErrors.stravaLink = "Strava link is required";
        this.errors.push("Strava link is required");
      }

      return this.errors.length === 0;
    },
  },
};
